import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var CartAlt = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "none",
    d: "M8.246 11h10l1.429-5H6.428z",
    key: "k0"
  }), React.createElement("path", {
    d: "M21 4H2v2h2.3l3.282 9.025A3.01 3.01 0 0010.401 17H19v-2h-8.599c-.419 0-.797-.265-.94-.658L8.973 13h9.273c.89 0 1.68-.598 1.923-1.451l1.793-6.274A1.003 1.003 0 0021 4zm-2.754 7h-10L6.428 6h13.247l-1.429 5z",
    key: "k1"
  }), React.createElement("circle", {
    cx: 10.5,
    cy: 19.5,
    r: 1.5,
    key: "k2"
  }), React.createElement("circle", {
    cx: 16.5,
    cy: 19.5,
    r: 1.5,
    key: "k3"
  }));
});
CartAlt.displayName = 'CartAlt';
export var CartAltDimensions = {
  height: 24,
  width: 24
};